module.exports = __webpack_public_path__ + "static/img/arrow_left.8bd84cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/arrow_left.png
// module id = QZcK
// module chunks = 16